import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Snippets = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="snippets-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.76748 3.76754C4.45902 3.076 5.39695 2.6875 6.37494 2.6875C7.35292 2.6875 8.29085 3.076 8.9824 3.76754C9.67394 4.45908 10.0624 5.39701 10.0624 6.375C10.0624 7.35299 9.67394 8.29092 8.9824 8.98246C8.71071 9.25414 8.401 9.47905 8.06576 9.65201L10.2465 10.9761L19.9833 5.06456C20.3964 4.81377 20.9346 4.94533 21.1854 5.35841C21.4362 5.77149 21.3046 6.30966 20.8915 6.56045L11.9324 11.9998L13.2011 12.7701C13.6141 13.0209 13.7457 13.559 13.4949 13.9721C13.2441 14.3852 12.7059 14.5167 12.2928 14.2659L10.2464 13.0234L8.06519 14.3477C8.40064 14.5207 8.71055 14.7457 8.9824 15.0175C9.67394 15.7091 10.0624 16.647 10.0624 17.625C10.0624 18.603 9.67394 19.5409 8.9824 20.2325C8.29085 20.924 7.35292 21.3125 6.37494 21.3125C5.39695 21.3125 4.45902 20.924 3.76748 20.2325C3.07594 19.5409 2.68744 18.603 2.68744 17.625C2.68744 16.647 3.07594 15.7091 3.76748 15.0175C4.05294 14.7321 4.38038 14.4983 4.73529 14.3221L8.56047 11.9997L4.74213 9.6813C4.38459 9.50474 4.05477 9.26975 3.76748 8.98246C3.07594 8.29092 2.68744 7.35299 2.68744 6.375C2.68744 5.39701 3.07594 4.45908 3.76748 3.76754ZM6.37494 8.3125C6.08574 8.3125 5.80322 8.24785 5.54668 8.12654L5.52996 8.11854C5.33711 8.02508 5.15933 7.89943 5.00492 7.74502C4.64157 7.38167 4.43744 6.88886 4.43744 6.375C4.43744 5.86114 4.64157 5.36833 5.00492 5.00498C5.36827 4.64163 5.86108 4.4375 6.37494 4.4375C6.8888 4.4375 7.38161 4.64163 7.74496 5.00498C8.10831 5.36833 8.31244 5.86114 8.31244 6.375C8.31244 6.88886 8.10831 7.38167 7.74496 7.74502C7.38161 8.10837 6.8888 8.3125 6.37494 8.3125ZM6.37494 15.6875C5.86108 15.6875 5.36827 15.8916 5.00492 16.255C4.64157 16.6183 4.43744 17.1111 4.43744 17.625C4.43744 18.1389 4.64157 18.6317 5.00492 18.995C5.36827 19.3584 5.86108 19.5625 6.37494 19.5625C6.8888 19.5625 7.38161 19.3584 7.74496 18.995C8.10831 18.6317 8.31244 18.1389 8.31244 17.625C8.31244 17.1111 8.10831 16.6183 7.74496 16.255C7.38161 15.8916 6.8888 15.6875 6.37494 15.6875Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4374 15.9375C18.4374 15.4543 18.8292 15.0625 19.3124 15.0625H20.4374C20.9207 15.0625 21.3124 15.4543 21.3124 15.9375C21.3124 16.4207 20.9207 16.8125 20.4374 16.8125H19.3124C18.8292 16.8125 18.4374 16.4207 18.4374 15.9375Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0624 15.9375C15.0624 15.4543 15.4542 15.0625 15.9374 15.0625H17.0624C17.5457 15.0625 17.9374 15.4543 17.9374 15.9375C17.9374 16.4207 17.5457 16.8125 17.0624 16.8125H15.9374C15.4542 16.8125 15.0624 16.4207 15.0624 15.9375Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6874 15.9375C11.6874 15.4543 12.0792 15.0625 12.5624 15.0625H13.6874C14.1707 15.0625 14.5624 15.4543 14.5624 15.9375C14.5624 16.4207 14.1707 16.8125 13.6874 16.8125H12.5624C12.0792 16.8125 11.6874 16.4207 11.6874 15.9375Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
